import {Injectable} from '@angular/core';
import {HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from 'src/app/auth/shared/services/auth.service';
import {SSO_URLS_LIST} from '../utils/sso-url-list';
import {CUSTOM_SWITCH_TEAM_HEADER} from '../utils/constants';

@Injectable()
export class CustomHeaderInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldExcludeSSOHeaders(request.url)) {
      request = request.clone({
        setHeaders: {
          'x-sso-request-origin': 'WIDGET_ORIGIN',
        },
      });
    }
    //Check context for custom context token
    const SUB_ACCOUNT_UNIT_ID = request.context.get(CUSTOM_SWITCH_TEAM_HEADER_CONTEXT);
    if (
      (this.authService.isUserAuthenticated() &&
        this.authService.isUserSwitchedToTeam &&
        request.headers.get('authorization') !== 'none') ||
      !!SUB_ACCOUNT_UNIT_ID
    ) {
      request = request.clone({
        setHeaders: {
          [CUSTOM_SWITCH_TEAM_HEADER]: SUB_ACCOUNT_UNIT_ID || this.authService.uWTargetSwitchId,
        },
      });
    }
    return next.handle(request);
  }

  shouldExcludeSSOHeaders(url: string): boolean {
    return SSO_URLS_LIST.some(ssoUrl => url.includes(ssoUrl));
  }
}

//Export context token to use it in request for sending some context in requests
export const CUSTOM_SWITCH_TEAM_HEADER_CONTEXT = new HttpContextToken<string>(() => null);
